import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    num: '1',
    title: 'Prepara tu Botiquín',
    desc: 'Consigue los 3 elementos clave de la lista de compras.'
  }, {
    num: '2',
    title: 'Inicia el Protocolo',
    desc: 'Sigue el menú de 72 horas para estabilizar tus hormonas.'
  }, {
    num: '3',
    title: 'Aplica el Apagón',
    desc: 'Usa la técnica sensorial si el antojo aparece, y mira cómo desaparece en minutos.'
  }];
  return <section className="py-24 px-4 relative" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-white mb-4" data-id="element-121">
            Cómo funciona el reinicio
          </h2>
          <p className="text-[#a0a0b0] font-inter text-lg" data-id="element-122">
            Un proceso simple, biológico y directo.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-24" data-id="element-123">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-[#161622] rounded-2xl p-8 border border-[#00d4ff]/10 relative overflow-hidden group hover:border-[#00d4ff]/40 transition-colors" data-id="element-124">
              <div className="absolute -right-4 -top-4 text-8xl font-playfair font-bold text-[#00d4ff]/5 group-hover:text-[#00d4ff]/10 transition-colors" data-id="element-125">
                {step.num}
              </div>
              <div className="w-12 h-12 bg-[#00d4ff]/20 rounded-full flex items-center justify-center text-[#00d4ff] font-bold text-xl mb-6 relative z-10" data-id="element-126">
                {step.num}
              </div>
              <h3 className="text-xl font-bold font-inter text-white mb-3 relative z-10" data-id="element-127">
                {step.title}
              </h3>
              <p className="text-[#a0a0b0] font-inter leading-relaxed relative z-10" data-id="element-128">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Proof / Believability */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-[#f5a623]/10 to-transparent border-l-4 border-[#f5a623] p-8 md:p-10 rounded-r-2xl" data-id="element-129">
          <div className="flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-130">
            <div className="bg-[#f5a623]/20 p-4 rounded-full shrink-0" data-id="element-131">
              <ShieldCheckIcon className="w-8 h-8 text-[#f5a623]" data-id="element-132" />
            </div>
            <div data-id="element-133">
              <p className="text-lg md:text-xl text-[#e0e0e0] font-inter leading-relaxed" data-id="element-134">
                En los primeros 3 días, tu umbral del gusto se reinicia. Lo que
                antes te parecía "normal", ahora te sabrá excesivamente dulce.
                Al tercer día, la{' '}
                <span className="text-[#f5a623] font-semibold" data-id="element-135">
                  inflamación de tu rostro desaparece
                </span>{' '}
                y recuperas la claridad mental que el azúcar te había robado.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}